import { render } from "./TrunkPageList.vue?vue&type=template&id=dac10044&scoped=true&ts=true"
import script from "./TrunkPageList.vue?vue&type=script&lang=ts"
export * from "./TrunkPageList.vue?vue&type=script&lang=ts"

import "./TrunkPageList.vue?vue&type=style&index=0&id=dac10044&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac10044"]])

export default __exports__